import React, { Component } from "react"
import match from "autosuggest-highlight/match"
import parse from "autosuggest-highlight/parse"
import renderHTML from "react-render-html"
import SearchGroupList from "./searchGroupList"
import Airports from "../searchGroups/airports"
import Arrivals from "../searchGroups/arrivals"
import Articles from "../searchGroups/articles"
import Category from "../searchGroups/category"
import Departures from "../searchGroups/departures"
import Merchants from "../searchGroups/merchants"
import Products from "../searchGroups/products"
import Brands from "../searchGroups/brands"
import * as trackingHelpers from "../../../helpers/tracking"

class SearchResult extends Component {
  // state = {
  //     dataConfig: {},
  //     isShop: false,
  // }

  // componentWillMount() {

  // }

  setMatches = (text, searchQuery, repeats = 1) => {
    let result = {}
    const matches = match(text, `${searchQuery} `.repeat(repeats)) // match up to 6 occurences
    const parts = parse(text, matches)
    result.matches = matches
    result.parts = parts
    return result
  }

  handleSearchClickTracking() {
    trackingHelpers.trackSiteSearch(this.props.eventCategory, "typeahead - result click", this.props.searchQuery, this.props.totalCount)
  }

  renderSearchGroups(searchGroup, results, count, searchQuery, index, setMatches, isZeroState = false, noResults = false) {
    const { dataConfig } = this.props
    switch (searchGroup) {
      case "ProductsTypeahead":
        return (
          <Products
            key={index}
            dataConfig={dataConfig}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
            trackProductClick={() => this.handleSearchClickTracking()}
          />
        )
      case "DepartureTypeahead":
        return (
          <Departures
            key={index}
            dataConfig={dataConfig}
            count={count}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
            trackProductClick={() => this.handleSearchClickTracking()}
          />
        )
      case "ArrivalsTypeahead":
        return (
          <Arrivals
            key={index}
            dataConfig={dataConfig}
            count={count}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
            trackProductClick={() => this.handleSearchClickTracking()}
          />
        )
      case "CategoryTypeahead":
        return (
          <Category
            key={index}
            dataConfig={dataConfig}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
            trackProductClick={() => this.handleSearchClickTracking()}
          />
        )
      case "MerchantsTypeahead":
        return (
          <Merchants
            key={index}
            dataConfig={dataConfig}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
            trackProductClick={() => this.handleSearchClickTracking()}
          />
        )
      case "ArticleTypeahead":
        return (
          <Articles
            key={index}
            dataConfig={dataConfig}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
            trackProductClick={() => this.handleSearchClickTracking()}
          />
        )
      case "AirportTypeahead":
        return (
          <Airports
            key={index}
            dataConfig={dataConfig}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
            trackProductClick={() => this.handleSearchClickTracking()}
          />
        )
      case "BrandsTypeahead":
        return (
          <Brands
            key={index}
            dataConfig={dataConfig}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
            trackProductClick={() => this.handleSearchClickTracking()}
          />
        )
      default:
        return (
          <SearchGroupList
            key={index}
            dataConfig={dataConfig}
            searchGroup={searchGroup}
            results={results}
            searchQuery={searchQuery}
            setMatches={setMatches}
            isZeroState={isZeroState}
            noResults={noResults}
          />
        )
    }
  }

  getTotalOfSearchResults = (data) => {
    if (!data) {
      return 0
    }
    let count = 0
    for (const key of Object.keys(data)) {
      count += data[key].count
    }
    return count
  }

  hasData(section, data, isZeroState = false) {
    let tempData = data
    if (data && Object.keys(data).length > 0) {
      return section.some((element) => {
        if (tempData[element] && tempData[element].length > 0) {
          if (isZeroState) {
            return true
          } else {
            return false
          }
        }
        if ((tempData[element] && tempData[element].count > 0) || (tempData[element] && tempData[element].docs.length > 0)) {
          if (tempData[element].docs.some((element) => element.isZeroData) && !isZeroState) {
            return false
          } else {
            return true
          }
        }
        return false
      })
    }
    return false
  }

  getSuggestion(sections, data, searchQuery) {
    let suggestion = ""
    if (data) {
      sections.forEach((element) => {
        if (data[element] && data[element].spellSuggestions && data[element].spellSuggestions.suggestions) {
          const suggestions = data[element].spellSuggestions.suggestions
          if (suggestions[searchQuery] && suggestions[searchQuery].numFound > 0) {
            suggestion = suggestions[searchQuery].suggestion[0]
          }
        }
      })
    }

    return suggestion
  }

  renderNoResults(isShop, noResults, sections, searchQuery, main = false, aside = false) {
    const { dataConfig } = this.props
    const { data } = this.props
    //NoShopResults
    if (noResults && isShop && main) {
      let text = dataConfig.noResults.Shop.noShop
      const suggestion = this.getSuggestion(sections, data, searchQuery)
      if (suggestion !== "") {
        text = dataConfig.noResults.Shop.noShopSuggest
        text = text.replace("{{suggestion}}", `<a href="${dataConfig.shopSearchUrl}?query=${suggestion}">${suggestion}?</a>`)
      }
      return (
        <React.Fragment>
          <p className="message">{renderHTML(text)}</p>
        </React.Fragment>
      )
    }
    //NoShopResults
    if (noResults && isShop && aside) {
      const otherSearchResultText =
        dataConfig.noResults && dataConfig.noResults.Shop ? dataConfig.noResults.Shop.otherSearchResults : "Resultater fra resten af CPH"
      return (
        <React.Fragment>
          <h6 className="trumpet">{otherSearchResultText}</h6>
          <ul className="general-search-panel__inner__list">
            {data
              ? Object.keys(data).map((element, index) => {
                  if (data[element].count > 0) {
                    return this.renderSearchGroups(element, data[element].docs, data[element].count, searchQuery, index, this.setMatches, false, true)
                  } else {
                    return ""
                  }
                })
              : ""}
          </ul>
        </React.Fragment>
      )
    }
  }

  renderMainSection(noResults, data, isZeroState) {
    const { searchQuery, dataConfig } = this.props
    const { isShop } = dataConfig || false
    // const { dataConfig, isShop } = this.state;
    const mainTop = dataConfig.sectionData ? dataConfig.sectionData.mainTop : []
    const mainBottom = dataConfig.sectionData ? dataConfig.sectionData.mainBottom : []
    if (noResults && isShop && !isZeroState) {
      return this.renderNoResults(isShop, noResults, [...mainTop, ...mainBottom], searchQuery, true)
    }
    //NoProductsResults
    if (!this.hasData(mainTop, data, isZeroState) && !this.hasData(mainBottom, data, isZeroState) && isShop && !isZeroState) {
      const noResultMainBottom = ["ArticlesTypeahead"]
      return (
        <React.Fragment>
          <ul className="general-search-panel__inner__list">
            <p className="message">{dataConfig.noResults.Shop.noProducts}</p>
          </ul>
          <ul className="general-search-panel__inner__list">
            {noResultMainBottom.map((element, index) =>
              data[element]
                ? this.renderSearchGroups(
                    element,
                    isZeroState ? data[element] : data[element].docs,
                    data[element].count,
                    searchQuery,
                    index,
                    this.setMatches,
                    isZeroState,
                  )
                : "",
            )}
          </ul>
        </React.Fragment>
      )
    }
    if (!isShop && !isZeroState) {
      if (mainBottom.indexOf("ArrivalsTypeahead") !== -1 && mainBottom.indexOf("DepartureTypeahead") !== -1) {
        if (data["ArrivalsTypeahead"] && data["DepartureTypeahead"]) {
          if (!data["ArrivalsTypeahead"].count === 0 && data["DepartureTypeahead"].count === 0) {
            let text = dataConfig.noResults.default.noFlights
            const suggestion = this.getSuggestion(mainBottom, data, searchQuery)
            if (suggestion !== "") {
              text = dataConfig.noResults.default.noFlightsSuggest
              text = text.replace("{{suggestion}}", `<a href="${dataConfig.siteSearchUrl}?query=${suggestion}">${suggestion}?</a>`)
            }
            return (
              <React.Fragment>
                <ul className="general-search-panel__inner__list">
                  <p className="message">{renderHTML(text)}</p>
                </ul>
                <ul className="general-search-panel__inner__list">
                  {mainTop.map((element, index) =>
                    data[element]
                      ? this.renderSearchGroups(
                          element,
                          isZeroState ? data[element] : data[element].docs,
                          data[element].count,
                          searchQuery,
                          index,
                          this.setMatches,
                          isZeroState,
                          true,
                        )
                      : "",
                  )}
                </ul>
              </React.Fragment>
            )
          }
        }
      }
    }
    return (
      <React.Fragment>
        {this.hasData(mainTop, data, isZeroState) ? (
          <ul className="general-search-panel__inner__list">
            {mainTop.map((element, index) =>
              data[element]
                ? this.renderSearchGroups(
                    element,
                    isZeroState ? data[element] : data[element].docs,
                    data[element].count,
                    searchQuery,
                    index,
                    this.setMatches,
                    isZeroState,
                  )
                : "",
            )}
          </ul>
        ) : (
          ""
        )}
        {this.hasData(mainBottom, data, isZeroState) ? (
          <ul className="general-search-panel__inner__list">
            {mainBottom.map((element, index) =>
              data[element]
                ? this.renderSearchGroups(
                    element,
                    isZeroState ? data[element] : data[element].docs,
                    data[element].count,
                    searchQuery,
                    index,
                    this.setMatches,
                    isZeroState,
                  )
                : "",
            )}
          </ul>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  renderAsideSection(noResults, data, isZeroState) {
    const { searchQuery, dataConfig } = this.props
    const { isShop } = dataConfig || false

    const asideTop = dataConfig.sectionData ? dataConfig.sectionData.asideTop : []
    const asideBottom = dataConfig.sectionData ? dataConfig.sectionData.asideBottom : []
    if (noResults && isShop && !isZeroState) {
      return this.renderNoResults(isShop, noResults, [...asideTop, ...asideBottom], searchQuery, false, true)
    }
    if (!this.hasData(asideTop, data, isZeroState) && !this.hasData(asideBottom, data, isZeroState) && !isZeroState && !isShop) {
      return (
        <React.Fragment>
          <div className="general-search-panel__inner__aside__logo">
            <img src={dataConfig.shopLogo} alt="" width="100" height="30" />
          </div>
          <p className="message">{dataConfig.noResults.default.noShop}</p>
        </React.Fragment>
      )
    }
    //NoCategoryResults
    if (data && !this.hasData(asideTop, data, isZeroState) && !this.hasData(asideBottom, data, isZeroState) && isShop) {
      const { displayGroupNames } = this.props
      const sections = [...asideTop, ...asideBottom]
      const hasData = this.hasData(sections, data, isZeroState)
      if (!hasData && sections.includes("CategoryTypeahead")) {
        let searchGroups = ""
        sections.forEach((element, index) => {
          let operator = index === 0 ? "" : ","
          if (displayGroupNames && displayGroupNames[element]) {
            if (index === sections.length - 1 && sections.length > 1) {
              operator = dataConfig.language === "da" ? "eller" : "or"
            }
            searchGroups += `${operator} ${displayGroupNames[element]}`
          }
        })
        let text = dataConfig.noResults.Shop.noCategory
        const suggestion = this.getSuggestion(sections, data, searchQuery)
        text = text.replace("{{searchGroups}}", searchGroups)
        if (suggestion !== "") {
          text = dataConfig.noResults.Shop.noCategorySuggest
          text = text.replace("{{suggestion}}", `<a href="${dataConfig.shopSearchUrl}?q=${suggestion}">${suggestion}?</a>`)
        }

        return (
          <React.Fragment>
            <p className="message">{renderHTML(text)}</p>
          </React.Fragment>
        )
      }
    }

    return (
      <React.Fragment>
        <div className="general-search-panel__inner__aside__logo">
          <img src={dataConfig.shopLogo} alt="" width="100" height="30" />
        </div>
        {this.hasData(asideTop, data, isZeroState) ? (
          <ul className="general-search-panel__inner__list">
            {asideTop.map((element, index) =>
              data[element]
                ? this.renderSearchGroups(
                    element,
                    isZeroState ? data[element] : data[element].docs,
                    data[element].count,
                    searchQuery,
                    index,
                    this.setMatches,
                    isZeroState,
                  )
                : "",
            )}
          </ul>
        ) : (
          ""
        )}
        {this.hasData(asideBottom, data, isZeroState) ? (
          <ul className="general-search-panel__inner__list">
            {asideBottom.map((element, index) =>
              data[element]
                ? this.renderSearchGroups(
                    element,
                    isZeroState ? data[element] : data[element].docs,
                    data[element].count,
                    searchQuery,
                    index,
                    this.setMatches,
                    isZeroState,
                  )
                : "",
            )}
          </ul>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  renderFooter(isZeroState, noResults, searchQuery) {
    const { dataConfig } = this.props
    const { isShop } = dataConfig || false
    let footerText = dataConfig.texts.footer.defaultText || ""
    footerText = footerText.replace("{{searchQuery}}", searchQuery)

    let searchUrl = isShop
      ? isZeroState
        ? dataConfig.shopSearchUrl
        : `${dataConfig.shopSearchUrl}?q=${searchQuery}&c=shop*`
      : isZeroState
        ? dataConfig.siteSearchUrl
        : `${dataConfig.siteSearchUrl}?query=${searchQuery}&c=global*`

    return (
      <a href={searchUrl} className="button button--small">
        <span className="text">{isZeroState ? dataConfig.zeroState.defaultText : footerText}</span>
      </a>
    )
  }

  render() {
    const { searchQuery, dataConfig } = this.props
    let data = this.props.data || {}

    const main = dataConfig.sectionData ? [...dataConfig.sectionData.mainTop, ...dataConfig.sectionData.mainBottom] : []
    const aside = dataConfig.sectionData ? [...dataConfig.sectionData.asideTop, ...dataConfig.sectionData.asideBottom] : []
    const isZeroState = searchQuery.length <= 1
    const noResults = !this.hasData(main, data, isZeroState) && !this.hasData(aside, data, isZeroState)

    if (searchQuery.length <= 1) {
      data = dataConfig.zeroState.data || {}
    }

    return (
      <React.Fragment>
        <div className="general-search-panel__inner__main">{this.renderMainSection(noResults, data, isZeroState)}</div>
        <div className="general-search-panel__inner__aside">{this.renderAsideSection(noResults, data, isZeroState)}</div>
        <footer className="general-search-panel__bottom">{this.renderFooter(isZeroState, noResults, searchQuery)}</footer>
      </React.Fragment>
    )
  }
}

export default SearchResult
